import { Route, Switch } from 'react-router-dom';
import { useGetPmpOptions } from './PmpOptions';
import { PmpSetupFlowPage } from './PmpSetupFlowPage';
import {
  useCreatePmpSetupFlowPageModel,
  useEditPmpSetupFlowPageModel,
  useSummaryPmpSetupFlowPageModel
} from './PmpSetupFlowPageModel';
import { PmpList } from './PmpList';
import { LoadingIndicator } from 'components/common/LoadingIndicator';

export const Pmp = () => {
  const {
    optionInited,
    channelOptions,
    channelSpaceOptionsMap,
    channelAgencyOptionsMap
  } = useGetPmpOptions();

  const renderPmpCreateForm = () => {
    return (
      <PmpSetupFlowPage
        channelOptions={channelOptions}
        channelSpaceOptionsMap={channelSpaceOptionsMap}
        channelAgencyOptionsMap={channelAgencyOptionsMap}
        useModel={useCreatePmpSetupFlowPageModel}
      />
    );
  };

  const renderPmpEditForm = () => {
    return (
      <PmpSetupFlowPage
        channelOptions={channelOptions}
        channelSpaceOptionsMap={channelSpaceOptionsMap}
        channelAgencyOptionsMap={channelAgencyOptionsMap}
        useModel={useEditPmpSetupFlowPageModel}
      />
    );
  };

  const renderPmpSummaryForm = () => {
    return (
      <PmpSetupFlowPage
        channelOptions={channelOptions}
        channelSpaceOptionsMap={channelSpaceOptionsMap}
        channelAgencyOptionsMap={channelAgencyOptionsMap}
        useModel={useSummaryPmpSetupFlowPageModel}
      />
    );
  };

  const renderPmpList = () => {
    const allSpaceOptions = Object.values(channelSpaceOptionsMap).flat();
    return <PmpList spaceOptions={allSpaceOptions} />;
  };

  if (!optionInited) {
    return <LoadingIndicator />;
  }

  return (
    <Switch>
      <Route path={'/pmp/new'} render={renderPmpCreateForm} />
      <Route path={'/pmp/:pmpId/edit'} render={renderPmpEditForm} />
      <Route path={'/pmp/:pmpId/summary'} render={renderPmpSummaryForm} />
      <Route render={renderPmpList} />
    </Switch>
  );
};
